import React from 'react'
import InlineNotification from '@veneer/core/dist/esm/scripts/inline_notification'

const FooterNote = ({ children }) => {
  return (
    <InlineNotification
      closeButton={false}
      customStyle={{
        backgroundColor: 'transparent',
        padding: '12px 0'
      }}
      description={children}
      hideIcon
      status="information"
    />
  )
}

export default FooterNote
